import {
  useAdminStore,
  useKnowledgeStore,
  useFavoritesStore,
} from '@getmayday/vue-modules';
import useLogs from './useLogs';
import useNotification from '../composables/useNotification';

const useApp = () => {
  const adminStore = useAdminStore();
  const knowledgeStore = useKnowledgeStore();
  const favoritesStore = useFavoritesStore();
  const configStore = useConfigStore();
  const router = useRouter();
  const route = useRoute();
  const { appRefresh } = useLogs();
  const { accessToken, refreshToken, accessExpirationDate } =
    storeToRefs(adminStore);
  const { notify } = useNotification();

  const refresh = async () => {
    const res = await adminStore.initSessionFromToken({
      accessToken: accessToken.value as string,
      refreshToken: refreshToken.value as string,
      accessExpirationDate: accessExpirationDate.value,
      isRefresh: true,
    });

    if (!res) {
      configStore.logAppBugTracking('APP_SESSION_EXPIRED');
      router.push({ name: 'login' });
      setTimeout(() => {
        notify({ type: 'error', text: 'app.notify-session-expired' });
      }, 500);
      return configStore.logout();
    }

    if (route.name === 'favorites') {
      favoritesStore.fetchCurrentTab();
    }

    configStore.initAppFromLogin();

    const entityRoutes = [
      'index',
      'knowledge-viewer',
      'collection-viewer',
      'content-viewer',
    ];

    if (entityRoutes.includes(route.name as string)) {
      const knowledgeId = knowledgeStore.knowledgeId;
      router.push({
        path: `/knowledges/${knowledgeId}`,
        query: { force: '1' },
      });
    }

    appRefresh();
    setTimeout(() => {
      notify('app.notify-refresh-success');
    }, 500);
  };

  const fixEmptyView = () => {
    configStore.logAppBugTracking('APP_EMPTY_VIEW');
    refresh();
    router.push({ path: '/' });
  };

  return {
    fixEmptyView,
    refresh,
  };
};

export default useApp;
